import { Organization, Owner } from "./ControlPanel";
import { AccessLevel } from "./generics";

export enum EnvVariableType {
  Number = "number",
  String = "string",
  Email = "email",
  Token = "token",
  JSON = "json",
}

export const environmentTypesOptions = Object.entries(EnvVariableType).map(([label, value]) => ({ label, value }));

export class EnvVariable {
  id?: number;
  type: string;
  name: string;
  description?: string;
  value: string | number;
  tags?: string[];
  owner?: Owner;
  organization?: Organization;
  accessLevel?: AccessLevel;
  createDateTime?: string;
  img?: string;
  isSecret?: boolean;

  constructor() {
    this.name = '';
    this.type = EnvVariableType.String;
    this.value = '';
    this.accessLevel = AccessLevel.PUBLIC;
  }
}